<ng-content/> <!-- https://github.com/angular/angular/issues/50543 -->

<div role="tablist" [attr.aria-label]="label" class="kb-scrollbar">
  @for (panel of panels; track panel.contentId) {
    <kb-variable-heading [level]="panel.headingLevel">
      <button
        type="button"
        role="tab"
        [attr.aria-selected]="panel === openPanel"
        [attr.aria-controls]="panel.contentId"
        [id]="panel.headerId"
        [attr.tabindex]="panel === openPanel ? undefined : -1"
        (click)="open(panel)"
        #headerButtonElement
      >
        <ng-container [ngTemplateOutlet]="panel.header"/>
      </button>
    </kb-variable-heading>
  }
</div>
<div class="panel-list" #panelListElement>
  @for (panel of panels; track panel.contentId) {
    <div role="tabpanel" [id]="panel.contentId" [attr.aria-labelledby]="panel.headerId" [class.selected]="panel === openPanel" #panelElement>
      <ng-container [ngTemplateOutlet]="panel.content"/>
    </div>
  }
</div>
